import styled, { css, keyframes } from 'styled-components';

import { ButtonVariants } from '@/types/styled';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const isLoadingStyles = css`
  color: transparent;
  cursor: wait;

  &::before {
    content: '';
    border: 2px solid ${({ theme }) => theme.system.blue};
    border-top-color: ${({ theme }) => theme.bg.main};
    border-radius: 50%;
    width: 16px;
    height: 16px;
    position: absolute;
    animation: ${spin} 1s linear infinite;
  }
`;

export const Button = styled.button<{
  $color?: string;
  $variant?: ButtonVariants;
  $noPadding?: boolean;
  $isLoading?: boolean;
}>`
  border: 1px solid transparent;
  outline: none;
  background: none;
  cursor: pointer;
  padding: ${({ $noPadding }) => ($noPadding ? 0 : '13px 16px')};
  transition-property: color, background-color, border-color;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
  ${({ $variant, $color, theme }) => {
    switch ($variant) {
      case ButtonVariants.Filled:
        return css`
          color: ${theme.bg.main};
          background-color: ${$color || theme.system.blue};
          border-radius: 14px;
        `;
      case ButtonVariants.Outlined:
        return css`
          color: ${$color || theme.text.main};
          border-color: ${$color || theme.text.main};
          background-color: transparent;
          border-radius: 14px;
        `;
      default:
        return css`
          color: ${$color || theme.text.main};
          background: transparent;
        `;
    }
  }}
  ${({ $isLoading }) => $isLoading && isLoadingStyles}
`;
export const ButtonFullWidth = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
